import Content from './Content';
import Date from './Date';
import Field from './Field';
import FieldList from './FieldList';
import Items from './Items';
import LongAnswer from './LongAnswer';
import Number from './Number';
import ShortAnswer from './ShortAnswer';
import typeMap from './typeMap';
import Upload from './Upload';

export const fields = {
    Content,
    Date,
    Field,
    FieldList,
    Items,
    LongAnswer,
    Number,
    ShortAnswer,
    typeMap,
    Upload,
};
